var render = function () {
  var _vm$application$perso, _vm$application$appli, _vm$application$appli2, _vm$application$appli3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "accent--text pb-4"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Заявление")])]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', {
    staticClass: "px-3 pt-2"
  }, [(_vm$application$perso = _vm.application.personalData) !== null && _vm$application$perso !== void 0 && _vm$application$perso.id ? [_c('v-col', {
    staticClass: "pt-4 px-0",
    attrs: {
      "cols": "12"
    }
  }, [((_vm$application$appli = _vm.application.applicationType) === null || _vm$application$appli === void 0 ? void 0 : _vm$application$appli.id) === 1 ? _c('ApplicationRecovery', {
    attrs: {
      "application": _vm.application
    }
  }) : _vm._e(), ((_vm$application$appli2 = _vm.application.applicationType) === null || _vm$application$appli2 === void 0 ? void 0 : _vm$application$appli2.id) === 2 ? _c('ApplicationOrganizationTransfer', {
    attrs: {
      "application": _vm.application
    }
  }) : _vm._e(), ((_vm$application$appli3 = _vm.application.applicationType) === null || _vm$application$appli3 === void 0 ? void 0 : _vm$application$appli3.id) === 3 ? _c('ApplicationEducationTransfer', {
    attrs: {
      "application": _vm.application
    }
  }) : _vm._e()], 1), _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('Documents', {
    attrs: {
      "application": _vm.application
    }
  })], 1)] : [_c('v-col', {
    staticClass: "pt-3 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("Нет данных")])])]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }